import { useContext, useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Argon Dashboard 2 MUI components
import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";
import useAuth from "hooks/useAuth";
import api from "configs/api";
import { AppContext } from "context/appContext";

function PlatformSettings() {
  const {
    isAdmin,
    isCompany,
    user
  } = useAuth()
  const { showAlert } = useContext(AppContext)
  const updateUserLoginAlertPreference = async (preference) => {
    setLoginAlert(preference);
    try {
      const response = await api.put('/auth/user/updateUserLoginAlertPreference', { id: user._id, sendLoginAlert: preference })
      if (response.data.status) {
        showAlert('Preference updated!', 'success', 'Login Alert Preference')
      } else {
        showAlert('Unable to update preference', 'error', 'Login Alert Preference')
        setLoginAlert(!preference);
      }
    } catch (error) {
      setLoginAlert(!preference);
      showAlert(error.message, 'error', 'Login Alert Preference')
    }
  };
  const [loginAlert, setLoginAlert] = useState(false);
  const [answersPost, setAnswersPost] = useState(false);
  const [courseCreated, setCourseCreated] = useState(false);
  const [companyCreated, setCompanyCreated] = useState(false);

  useEffect(() => {
    setLoginAlert(user.sendLoginAlert ?? false)


  }, [user])

  return (
    <Card>
      <Box pt={2} px={2}>
        <Typography variant="h6" fontWeight="medium" textTransform="capitalize">
          platform settings
        </Typography>
      </Box>
      <Box pt={1.5} pb={2} px={2} lineHeight={1.25}>
        <Typography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
          account
        </Typography>
        <Box display="flex" py={1} mb={0.25}>
          <Box mt={0.25}>
            <Switch checked={loginAlert} onChange={(e) => updateUserLoginAlertPreference(e.target.checked)} />
          </Box>
          <Box width="80%" ml={2}>
            <Typography variant="button" fontWeight="regular" color="text">
              Email me when i login
            </Typography>
          </Box>
        </Box>
        {isCompany && <Box display="flex" py={1} mb={0.25}>
          <Box mt={0.25}>
            <Switch checked={answersPost} onChange={() => setAnswersPost(!answersPost)} />
          </Box>
          <Box width="80%" ml={2}>
            <Typography variant="button" fontWeight="regular" color="text">
              Email me when a course is assigned
            </Typography>
          </Box>
        </Box>}
        {isAdmin && <Box display="flex" py={1} mb={0.25}>
          <Box mt={0.25}>
            <Switch checked={answersPost} onChange={() => setAnswersPost(!answersPost)} />
          </Box>
          <Box width="80%" ml={2}>
            <Typography variant="button" fontWeight="regular" color="text">
              Email me when a course is created
            </Typography>
          </Box>
        </Box>}
        {isAdmin && <Box display="flex" py={1} mb={0.25}>
          <Box mt={0.25}>
            <Switch checked={answersPost} onChange={() => setAnswersPost(!answersPost)} />
          </Box>
          <Box width="80%" ml={2}>
            <Typography variant="button" fontWeight="regular" color="text">
              Email me when a company signs up
            </Typography>
          </Box>
        </Box>}
        {/* <Box mt={3}>
          <Typography
            variant="caption"
            fontWeight="bold"
            color="text"
            textTransform="uppercase"
          >
            application
          </Typography>
        </Box>
        <Box display="flex" py={1} mb={0.25}>
          <Box mt={0.25}>
            <Switch checked={newLaunches} onChange={() => setNewLaunches(!newLaunches)} />
          </Box>
          <Box width="80%" ml={2}>
            <Typography variant="button" fontWeight="regular" color="text">
              New launches and projects
            </Typography>
          </Box>
        </Box>
        <Box display="flex" py={1} mb={0.25}>
          <Box mt={0.25}>
            <Switch checked={productUpdate} onChange={() => setProductUpdate(!productUpdate)} />
          </Box>
          <Box width="80%" ml={2}>
            <Typography variant="button" fontWeight="regular" color="text">
              Monthly product updates
            </Typography>
          </Box>
        </Box>
        <Box display="flex" py={1} mb={0.25}>
          <Box mt={0.25}>
            <Switch checked={newsletter} onChange={() => setNewsletter(!newsletter)} />
          </Box>
          <Box width="80%" ml={2}>
            <Typography variant="button" fontWeight="regular" color="text">
              Subscribe to newsletter
            </Typography>
          </Box>
        </Box> */}
      </Box>
    </Card>
  );
}

export default PlatformSettings;
